import { render, staticRenderFns } from "./MessageTemplatesCreateDetail.vue?vue&type=template&id=34a8bb16"
import script from "./MessageTemplatesCreateDetail.vue?vue&type=script&lang=js"
export * from "./MessageTemplatesCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplatesCreateDetail.vue?vue&type=style&index=0&id=34a8bb16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports